import { observeElement, getWidget } from '@uvocore-front/utils';

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('[data-testimonials-list]')) {
    const monthNames = [
      'Jan', 'Feb', 'Mar',
      'Apr', 'May', 'Jun', 'Jul',
      'Aug', 'Sep', 'Oct',
      'Nov', 'Dec',
    ];

    const template = (i) => {
      let date = new Date(i.createdAt * 1000);
      date = `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;

      return (
        `<div class="testimonial__item tm_all">
        <div class="testimonial__item-body">
            <h3 class="main_h3">
               <span>Customer’s comment (${i.customerId}):</span>
            </h3>
            <div class="testimonial__item-days">${date}</div>
            <div class="testimonial__item-comment"><p>${i.body}</p></div>
          </div>
          <div class="testimonial__item-about">
              <p class="main_h3">
                    Topic title:&nbsp;<strong>${i.orderTopic}</strong>
              </p>
          <p class="main_h3">
            Discipline:&nbsp;<strong>${i.orderDiscipline}</strong>
          </p>
          <p class="main_h3">
            Pages:&nbsp;<strong>${i.orderPages}</strong>
          </p>
        </div>
        </div>`
      );
    };


    observeElement({
      element: '[data-testimonials-list]',
      marginValue: 200,
      callback: () => {
        getWidget({
          widgetLink: '/assets/js/testimonialsWidget.min.js',
          insertLoaderTo: '[data-testimonials-list]',
          loader: false,
          fn: () => {
            observeElement({
              element: '[data-testimonials-list]',
              marginValue: 200,
              callback: () => {
                window.tmWidget({
                  params: {
                    siteId: '65',
                    limit: 10,
                    minBodyLength: 0,
                  },
                  template,
                  type: 'html',
                  moreEl: '.load-more',
                  containerEl: '[data-testimonials-list]',
                  loader: true,
                });
              },
            });
          },
        });
      },
    });
  }
});
